import * as React from "react"
import { ImgHTMLAttributes } from "react"

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
    lowResSrc?: string
    hiResSrc?: string
    onLoad?: () => void
}

interface State {
    isLoading: boolean
    shouldLoadHiRes: boolean
}

export default class Thumbnail extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = { isLoading: true, shouldLoadHiRes: false }
    }

    render(): JSX.Element {
        const { lowResSrc, hiResSrc, onLoad, ...attrs } = this.props
        const { isLoading, shouldLoadHiRes } = this.state

        return (
            <>
                {isLoading && (
                    <img
                        src={lowResSrc}
                        onLoad={this.onLoadLowRes}
                        {...attrs}
                    />
                )}

                {shouldLoadHiRes && hiResSrc && (
                    <img
                        src={hiResSrc}
                        hidden={isLoading}
                        onLoad={this.onLoadHiRes}
                        {...attrs}
                    />
                )}
            </>
        )
    }

    onLoadLowRes = (): void => {
        this.setState(
            { shouldLoadHiRes: true },
            !this.props.hiResSrc ? this.props.onLoad : undefined,
        )
    }

    onLoadHiRes = (): void => {
        this.setState({ isLoading: false }, this.props.onLoad)
    }
}
